import { render, staticRenderFns } from "./wsCountdownBeforeStart.vue?vue&type=template&id=4f4e6a12&scoped=true&"
import script from "./wsCountdownBeforeStart.vue?vue&type=script&lang=js&"
export * from "./wsCountdownBeforeStart.vue?vue&type=script&lang=js&"
import style0 from "./wsCountdownBeforeStart.vue?vue&type=style&index=0&id=4f4e6a12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4e6a12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
